module.exports = new __parcel__URL__("seahorse-ios7.d2fb26c0.png").toString();